import 'css-chunksrc/client/scenes/listDuplication/listsList/list/milestone/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_10vv0_1",
  "form": "_form_10vv0_6",
  "name": "_name_10vv0_1",
  "icon": "_icon_10vv0_26",
  "input": "_input_10vv0_30",
  "late": "_late_10vv0_51",
  "completed": "_completed_10vv0_58",
  "edition": "_edition_10vv0_65"
};